import { IconButton } from "@/components/atoms/IconButton/IconButton";

export type CopyButtonProps = {
  onClick: () => void;
  className?: string;
  disabled?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const CopyButton: React.FC<CopyButtonProps> = ({ onClick, className = "", disabled = false, ...props }) => {
  return (
    <IconButton
      className={`copy-button ${className}`}
      iconName="content_copy"
      ariaLabel="Copy tab"
      onClick={onClick}
      disabled={disabled}
      {...props}
    />
  );
};
